/**
 * Short IKON Guest waiver signature information.
 */

export type WaiverSignature = {
  version: string;
  firstName: string;
  lastName: string;
  dateOfBirth: Date | string;
}

/**
 * Empty model satisfying the 'identity element' part of a monoid.
 */
export const EMPTY_SIGNATURE: WaiverSignature = {
  version:     '',
  firstName:   '',
  lastName:    '',
  dateOfBirth: '',
};
